/**
 * URL pubblico del sito. Valore fisso (non da process.env né da window.location)
 * perché durante react-snap Chrome gira su http://localhost:45678 e qualsiasi
 * lettura runtime del location finirebbe nel canonical/og:url dell'HTML salvato.
 */
export const SITE_URL = 'https://virtualclinic.it';
